import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/houses/$houseId/roster-of-care/$rosterId/'
)({
  // The version page itself: the layout already mounted the shell, and the
  // shell's `index` step navigates on to the week. Nothing left to render.
  component: () => null,
})
